import { openMembershipDrawer } from "./membership_drawer.js";

const tickerSelector = "[data-community-ticker]";
// Preserve dismissal across Turbo visits, but show the ticker again after a reload.
let dismissed = false;

function restoreTickers(root = document) {
  root.querySelectorAll(tickerSelector).forEach((ticker) => {
    ticker.hidden = dismissed;
  });
}

document.addEventListener("click", (event) => {
  const closeButton = event.target.closest?.("[data-community-ticker-close]");
  if (closeButton) {
    const ticker = closeButton.closest(tickerSelector);
    const restoreFocus = ticker.contains(document.activeElement);
    dismissed = true;
    ticker.hidden = true;

    if (restoreFocus) {
      document.querySelector("[data-membership-trigger]")?.focus({ preventScroll: true });
    }
    return;
  }

  const signup = event.target.closest?.("[data-community-ticker-signup]");
  if (!signup || event.defaultPrevented || event.button !== 0 ||
      event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  if (!document.querySelector("[data-membership-root]")) return;

  event.preventDefault();
  openMembershipDrawer("registration", signup);
});

document.addEventListener("turbo:before-render", (event) => restoreTickers(event.detail.newBody));
document.addEventListener("turbo:load", () => restoreTickers());
window.addEventListener("pageshow", () => restoreTickers());

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => restoreTickers());
} else {
  restoreTickers();
}
